import { InputGroup } from '../edit/components/layout/InputGroup';
import { InputText } from 'primereact/inputtext';
import { createSearchParams, NavigateFunction, Location, useLocation, useNavigate, useSearchParams } from 'react-router';
import * as React from 'react';
import { ChangeEvent, ReactNode, useEffect } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { EntityType } from '../../util/types';
import { entityTypes } from '../../Settings/data';
import { Button } from 'primereact/button';
import { SelectItem } from 'primereact/selectitem';
import { userConfig } from '../../Settings/user-config';

export const EmbeddedSearchbar = (): ReactNode => {
  const intl: IntlShape = useIntl();
  const navigate: NavigateFunction = useNavigate();
  const location: Location<any> = useLocation();
  const [searchParams] = useSearchParams();
  const [search, setSearch] = React.useState<string>('');
  const [type, setType] = React.useState<EntityType>(searchParams.get('q') || 'work');

  useEffect((): void => {
    switch (location.pathname) {
      case '/search/persons':
        setType('person');
        break;
      case '/search/organisations':
        setType('organisation');
        break;
      case '/search/projects':
        setType('project');
        break;
      case '/search/works':
      case '/':
      default:
        setType('work');
        break;
    }
    setSearch(searchParams.get('q') || '');
  }, [location, searchParams]);

  const submit = (): void => {
    const params: URLSearchParams =
      location.pathname === `/search/${type}s` && userConfig.keepFacetsOnSearchStringChange ? createSearchParams({ ...searchParams }) : createSearchParams();
    if (search.length > 0) {
      params.set('q', search);
    } else {
      params.delete('q');
    }
    void navigate({
      pathname: `/search/${type}s`,
      search: params.toString(),
    });
  };

  return (
    <form
      onSubmit={(e): void => {
        e.preventDefault();
        submit();
      }}
      className={'w-full min-w-8rem'}
    >
      <InputGroup className={'shadowed border-round-md flex'}>
        <InputText
          placeholder={intl.formatMessage({ id: 'layout.header.search' })}
          type="text"
          className={'w-full'}
          value={search}
          onChange={(e: ChangeEvent<HTMLInputElement>): void => setSearch(e.target.value)}
        />
        <Dropdown
          id={'search.type'}
          className={'w-15rem border-white bg-primary border-none border-right-1'}
          pt={{input: { className: 'text-white'}, trigger: { className: 'text-white'}}}
          value={type}
          options={entityTypes.map(
            (type: string): SelectItem => ({ value: type, label: intl.formatMessage({ id: `entity.${type}s` }) })
          )}
          onChange={(e: DropdownChangeEvent): void => setType(e.target.value as string)}
        />
        <Button
          icon={'pi pi-search'}
          className={'w-3rem'}
          onClick={(): void => submit()}
        />
      </InputGroup>
    </form>
  );
};
